import {  toast ,ToasterProps} from "sonner";
import {AlertCloseButton} from "@/components/ui/alertComponent";

const AlertPosition: ToasterProps['position'] = "top-right";

const showToast = (message: string, type: ToasterProps['ToastOptions'] = 'info', options: ToasterProps['ToastOptions'] = {}) => {
    try {
        if(typeof message !== "string"){
            message = JSON.stringify(message);
        }
        const toastOptions: ToasterProps['ToastOptions'] = {
            pauseOnFocusLoss: false,
            closeButton: AlertCloseButton,
            ...options,
            duration: 5000,
            richColors: true,
        };

        switch (type) {
            case 'info':
                toast.info(message, toastOptions);
                break;
            case 'success':
                toast.success(message, toastOptions);
                break;
            case 'error':
                toast.error(message, toastOptions);
                break;
            case 'warning':
                toast.warning(message, toastOptions);
                break;
            default:
                toast.dark(message, toastOptions);
                break;
        }
    } catch (error) {
        console.error('Error showing toast:', error);
        // Fallback to console log if toast fails
    }
}

const AlertService = {
    showToast,
    AlertPosition
}

export default AlertService;
